.picture {
  display: block;
  width: 100%;
  position: relative;
}

.picture img {
  display: block;
  width: 100%;
  max-height: 100%;
  object-fit: contain;
}
